import { Tree, TreeProps, ValueProps } from '@mews/b2b-ui';
import { ControllerProps, useControllerHandler } from '@mews/framework';

export type TreeInputValue = string[] | string | null;

type TreeFieldProps = Omit<TreeProps, 'id'> &
    ControllerProps<TreeInputValue> &
    Omit<ValueProps, 'onChange'> & { onChange?: (value: TreeInputValue) => void };

export const TreeField = ({
    name,
    transform,
    onChange,
    defaultValue,
    rules,
    shouldUnregister,
    ...other
}: TreeFieldProps) => {
    const { value, handleChange, error } = useControllerHandler<TreeInputValue>({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });

    const props = {
        onChange: (newValue: TreeInputValue) => handleChange(null, newValue),
        error,
    };

    return <Tree value={value} id={name} {...props} {...other} />;
};
